import { appVariant } from '@util/AppUtils';
import { isReferred } from '@util/Cohorts';
import { StoreStateInternal } from '../store/Store';
import { FlowConfig } from './FlowTypes';
import { MENO_CONFIG, MenoAssessmentScreen } from './meno/MenoConfig';
import { NERVA_CONTROL_CONFIG, NervaControlScreen } from './nerva/NervaControl';
import { NERVA_HCP_REFERRED_PERSONALISE_CONFIG } from './nerva/NervaHCPReferredPersonalise';
import { PAIN_CONTROL_CONFIG, PainControlAssessmentScreen } from './pain/PainControlConfig';
import { QUIT_CONFIG, QuitAssessmentScreen } from './quit/QuitConfig';

type NervaFlowConfig = FlowConfig<NervaControlScreen>;
type MenoFlowConfig = FlowConfig<MenoAssessmentScreen>;
type QuitFlowConfig = FlowConfig<QuitAssessmentScreen>;
type PainFlowConfig = FlowConfig<PainControlAssessmentScreen>;

export type FlowConfigs = NervaFlowConfig | MenoFlowConfig | QuitFlowConfig | PainFlowConfig;

/** The flow config for the current product. Nerva has a Direct and a Referred flow. */
export function chooseAssessmentConfig(state: StoreStateInternal): FlowConfigs {
  return appVariant<FlowConfigs>({
    nerva: isReferred(state) ? NERVA_HCP_REFERRED_PERSONALISE_CONFIG : NERVA_CONTROL_CONFIG,
    meno: MENO_CONFIG,
    quit: QUIT_CONFIG,
    pain: PAIN_CONTROL_CONFIG,
  });
}
